import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = ["data-heap"]

import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import {useTranslation} from '@malt/vue3-use';
    import {onMounted, ref, watch} from 'vue';
    import {string} from 'vue-types';

    type DescriptionEvents = {
        (e: 'update:modelValue', textarea: string): void;
        (e: 'additional-functional-skills:updated', skills: string[]): void;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Description',
  props: {
        modelValue: string().isRequired,
        dataHeapTooltipID: string().def('profile-creation-tooltip-description'),
    },
  emits: ["update:modelValue", "additional-functional-skills:updated"],
  setup(__props, { emit: emits }) {

const props = __props;

    const {msg} = useTranslation();

    
    

    const refDescription = ref<HTMLElement>();
    const refTextarea = ref<HTMLJoyTextareaElement>();
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    onMounted(() => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#completion-description-bottom-sheet',
            props.dataHeapTooltipID,
            refDescription.value,
            'div.profile-creation-wizard',
        );
        bottomSheetDisplayer.value.mounted();
    });

    // Temporary fix for auto-grow
    /* watch(
        () => refDescription.value,
        () => {
            setTimeout(() => {
                refTextarea.value.forceRunAutoGrow();
            }, 500);
        },
    ); */

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

    function emitFocus(): void {
        eventBusProfileCreationWizard.emit('wizard:description-focus');
    }

    function emitUpdateModelValue(event: CustomEvent<{value: string}>): void {
        const textarea = event.target as HTMLTextAreaElement;
        emits('update:modelValue', textarea.value);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_textarea = _resolveComponent("joy-textarea")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refDescription",
    ref: refDescription,
    onFocusin: emitFocus
  }, [
    _createVNode(StepItemTitle, { "is-optional": true }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.description.title')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.description.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": __props.dataHeapTooltipID,
        onClick: openBottomSheet
      }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.description.help')), 9, _hoisted_2)
    ]),
    _createVNode(_component_joy_textarea, {
      id: "description",
      ref_key: "refTextarea",
      ref: refTextarea,
      "auto-grow": "",
      "data-testid": "description-text-area",
      minlength: "200",
      maxlength: "2000",
      value: props.modelValue,
      onJoyTextareaChange: emitUpdateModelValue
    }, null, 8, ["value"])
  ], 544))
}
}

})